import * as React from 'react';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {ExCircleIcon} from 'shells/icon/svg/ex-circle-icon';
import {TwoLineMiniCard} from 'shells/two-line/two-line-mini-card';

import styles from './activate-form-modal.module.css';

type Props = {
    fieldCount: number;
};

export function IgnoredFieldsSection(props: Props) {
    const fieldCountText = `${props.fieldCount} field${props.fieldCount === 1 ? '' : 's'}`;
    const fieldCountVerb = props.fieldCount === 1 ? 'is' : 'are';

    return (
        <div className={styles['fields-section']}>
            <div className={styles.description}>
                <strong>{fieldCountText}</strong> {fieldCountVerb} <i>ignored</i> and won’t add any
                data:
            </div>
            <TwoLineMiniCard
                icon={ExCircleIcon}
                iconColor={colors.offWhiteMd}
                iconSize={16}
                topRow='Ignored'
                bottomRow={fieldCountText}
                width={325}
            />
        </div>
    );
}
